import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { getTokenValidity } from '@/features/auth/api/get-token-validity';
import type { AuthSession } from '@/features/auth/types/auth';
import { useAuthStore } from '@/stores/auth-store';

export const useAuthSession = (): AuthSession => {
  const { isAuthenticated, setAuthenticated } = useAuthStore();
  const { isFetching, isSuccess } = useQuery({
    queryKey: ['validationData'],
    queryFn: getTokenValidity,
    enabled: !isAuthenticated,
  });

  useEffect(() => {
    if (isSuccess && !isAuthenticated) {
      setAuthenticated(true);
    }
  }, [isSuccess, isAuthenticated, setAuthenticated]);

  return {
    isLoading: isFetching,
    isAuthenticated: isAuthenticated,
  };
};
